// extracted by mini-css-extract-plugin
export default {"heroImage":"Narozeniny_heroImage__KXxA3","colored":"Narozeniny_colored__li6ZP"};